<template>
  <div>
    <HeaderInnerPage
      id="how-works"
      title="Está Precisando de Ajuda?"
      :background="bgPage"
    >Não se preocupe, estamos aqui para te ajudar!
    </HeaderInnerPage>

    <section class="pb-5">
      <b-container>
        <b-row class="mt-0 mt-lg-3">
          <b-col lg="5" class="" align-self="center">

            <div class="text-center text-lg-left">
              <h2 class="mb-5 mb-lg-3">Confira nossas dúvidas frequentes.</h2>
              <p class="text-muted lead">Sua pergunta pode já estar respondida nessa lista. Caso sua dúvida não esteja por aqui, entre em contato com a gente.</p>
              <img class="img-fluid d-block d-lg-none mt-5 mt-lg-0 mb-5 mb-lg-0" src="../assets/img/fique-tranquilo-estamos-aqui-para-ajuda-lo.svg" alt="Icone"/>
            </div>

          </b-col>

          <b-col lg="7" class="mt-5 mt-lg-3 d-none d-lg-block">
            <img class="img-fluid" src="../assets/img/fique-tranquilo-estamos-aqui-para-ajuda-lo.svg" alt="Icone"/>
          </b-col>

        </b-row>

        <b-row class="mt-3 pb-3">
          <b-col>
             <h4>Para ciclistas</h4>
            <el-collapse
               accordion
               class="accordion-pedale">
              <el-collapse-item v-for="(item, index) in faqCustomer" :key="index" :title="item.title" :name="index">
                <p v-html="item.desc"></p>
              </el-collapse-item>
            </el-collapse>
          </b-col>
        </b-row>

         <b-row class="mt-5 pb-3">
            <b-col>
               <h4>PARA ANFITRIÕES: Cadastros CPF e CNPJ</h4>
               <el-collapse
                  accordion
                  class="accordion-pedale">
                  <el-collapse-item v-for="(item, index) in faqOwner" :key="index" :title="item.title" :name="index">
                     <p v-html="item.desc"></p>
                  </el-collapse-item>
               </el-collapse>
            </b-col>
         </b-row>

         <b-row class="mt-3 pb-3">
            <b-col>
              <p>Ainda está com alguma dúvida? <router-link to="/contato">Entre em contato conosco  →</router-link></p>
            </b-col>
         </b-row>


      </b-container>
    </section>

    <CallToActionSection
      class="mt-5"
      title="Você tem um negócio de locação de bikes?"
      :desc="descAds"
      textLink="FALAR COM UM CONSULTOR DA PEDALE"
      :isHref="true"
      target="_new"
      link="https://wa.me/5551983599666"
      :bg="bgNegocioLocacao"
    />

  </div>
</template>

<script>
    import bgPage from '@/assets/img/ajuda-pedale.jpg';
    import bgNegocioLocacao from '@/assets/img/negocio-de-locacao.jpg';
    import HeaderInnerPage from "@/components/HeaderInnerPage.vue";
    import CallToActionSection from "@/components/CallToActionSection";
    import {metaTags} from "@/helpers";


    export default {
        name: 'Help',
        metaInfo: metaTags(`Ajuda`),
        components: {
            HeaderInnerPage,
            CallToActionSection,
        },
        data() {
            return {
                bgPage,
                bgNegocioLocacao,
                activeName: '1',
               faqCustomer: [
                  {
                     title: 'COMO FAZER UMA RESERVA?',
                     desc: 'Na página principal do site (para acessar clique no logo da Pedale no canto superior esquerdo ou <a href="/">aqui</a>) e siga os passos: <ol><li>Autorize o uso da sua localização ou digite o nome da cidade aonde quer pedalar; </li><li>Se houver disponibilidade, as bikes aparecerão, então escolha uma, clique em “ver bicicleta”</li><li>Selecione as datas/horas e clique em “solicitar bicicleta”; PRONTO!</li></ol><p>OBS: Faça a reserva sem custos para conversar com o anfitrião pelo chat da plataforma.</p>'
                  },
                  {
                     title: 'DEPOIS DE RESERVAR, COMO PEGO A BICICLETA?',
                     desc: 'Muitos anfitriões fazem delivery (entregam e buscam a bike), é só você combinar com ele pelo chat da plataforma. Você receberá o endereço da bike quando o anfitrião aprovar a sua reserva.'
                  },
                  {
                     title: 'COMO FAZER O PAGAMENTO?',
                     desc: 'No momento, a Pedale não está intermediando o pagamento, então, precisa pagar direto para o anfitrião, combine com ele se será via PIX, cartão de débito/crédito, dinheiro. Alguns solicitam um valor antecipado para confirmar a locação.'
                  },
                  {
                     title: 'É SEGURO ALUGAR UMA BICICLETA PELA PLATAFORMA?',
                     desc: 'Analisamos e aprovamos todos os anfitriões para você ter uma locação segura. \n' +
                        'Caso você pague por uma locação e não receba a bicicleta, nós devolveremos o valor pago. Não nos responsabilizamos por conversas e acertos realizados fora da plataforma.'
                  },
                  {
                     title: 'E SE EU PRECISAR CANCELAR UMA RESERVA?',
                     desc: 'Você pode cancelar a qualquer momento, sem custos.'
                  },
                  {
                     title: 'E SE EU PRECISAR ALTERAR AS DATAS?',
                     desc: 'Nesse caso, você vai precisar cancelar a reserva e fazer outra.'
                  },
               ],
               faqOwner: [
               {
                  title: 'COMO SER ANFITRIÃO DE BIKE NA MINHA CIDADE?',
                  desc: 'É muito simples, faça o login na plataforma, complete o seu cadastro enviando os documentos em “verificações”.' +
                     '<br/>' +
                     'Depois clique em Painel do Anfitrião + Minhas bicicletas + Cadastrar Bicicleta e preencha as informações, finalizando com belas fotos da sua bike!\n' +
                     '<br/>' +
                     '<a href="https://pedale.net.br/blog/2023/09/26/anfitriao-de-bicicleta/" target="_blank">Clique aqui</a> para mais informações'
               },
               {
                  title: 'QUANTAS BICICLETAS POSSO CADASTRAR? ',
                  desc: 'Quantas você quiser. Vamos juntos construir uma solução em mobilidade sustentável!'
               },
               {
                  title: 'QUAIS INFORMAÇÕES TENHO ACESSO NA HORA DE APROVAR UMA RESERVA?',
                  desc: 'Criamos um recurso de verificação dos ciclistas. Veja mais informações <a href="https://pedale.net.br/blog/2023/01/11/seguranca-da-plataforma-pedale/" target="_blank">aqui</a>.' +
                     '<br />' +
                     'Quando você receber uma reserva, poderá visualizar quais informações foram verificadas (ex: documento pessoal, endereço, foto, telefone, redes sociais). Caso não fique satisfeito, poderá solicitar o complemento diretamente ao ciclista, pelo chat da plataforma.\n'
               },
               {
                  title: 'EXISTE ALGUM TIPO DE SEGURO PARA A BICICLETA?',
                  desc: 'Sim, temos um seguro com cláusula específica para casos de locação. Orçamentos e contratação online e com apólice pelo nosso whatsapp.'
               },
            ],
               descAds: '<b>Disponibilizamos um sistema de gestão das suas locações!<br> Você poderá gerar os próprios pedidos da sua loja e controlar cada um deles por qualquer celular ou computador que tenha acesso à internet.</b> <br><br> Disponível para cadastros CNPJ. Para assinar o plano é só chamar a gente.'

            }
        },
    }
</script>

<style lang="scss">
   .el-collapse-item__content{
      font-size: 1rem !important;
   }
</style>
